import { Injectable } from '@angular/core';
import {
  EntitiesModel,
  ItemsModel,
  OccEndpointsService,
  ProductActions,
  SearchConfig
} from "@lm-nx-frontend/lm-inf-core";
import {Observable} from "rxjs";
import {Customer} from "../model/customer";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class CustomersConnector {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly occEndpointsService: OccEndpointsService,
  ) { }


  search(
    userId: string,
    query: string | undefined,
    searchConfig?: SearchConfig
  ): Observable<ItemsModel<Customer>> {
    const url = this.occEndpointsService.buildUrl('customers', {
      urlParams: {
        userId,
      },
      queryParams: {
        ...searchConfig,
        query,
      }
    })

    return this.httpClient.get<ItemsModel<Customer>>(url);
  }

  getList(
    userId: string,
    params?: SearchConfig
  ): Observable<ItemsModel<Customer>> {
    const url = this.occEndpointsService.buildUrl('customers', {
      urlParams: {
        userId,
      },
      queryParams: params
    })

    return this.httpClient.get<ItemsModel<Customer>>(url);
  }
}
